import { useEffect, useState } from 'react';
import useAppSnackbar from './useAppSnackbar';
import { getProjects } from '../services/api/projectService';
import { Project } from '../models/project';
import { DEFAULT_PAGE_SIZE } from '../constants';

interface UseGetProjectsReturnType {
  projects: Project[];
  isLoading: boolean;
}

export function useGetProjects(
  filter: string,
  skip: boolean
): UseGetProjectsReturnType {
  const { onErrorSnackbar } = useAppSnackbar();
  const [projects, setProjects] = useState<Project[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (skip) {
      return;
    } else {
      setIsLoading(true);
      getProjects({ take: DEFAULT_PAGE_SIZE, ...(filter && { filter }) })
        .then((response) => {
          setProjects(response.items);
        })
        .catch(onErrorSnackbar)
        .finally(() => setIsLoading(false));
    }
  }, [filter, onErrorSnackbar, skip]);

  return { projects, isLoading };
}
